<form [formGroup]="form" class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'scoring.configureScoring' | translate }}</h2>
      <p class="text-muted small mb-0">{{ eventClass.class_name }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (loading) {
      <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      <div class="row g-4 spacing-15">
        <div class="col-12">
          <label class="form-label">{{ 'scoring.scoreType' | translate }} *</label>
          <div class="score-type-options">
            @for (option of scoreTypeOptions; track option.value) {
              <div
                class="score-type-card"
                [class.selected]="form.get('score_type')?.value === option.value"
                (click)="form.get('score_type')?.setValue(option.value)"
              >
                <div class="score-type-icon">
                  @switch (option.value) {
                    @case ('timed') {
                      <i class="fa-solid fa-stopwatch"></i>
                    }
                    @case ('points_high') {
                      <i class="fa-solid fa-arrow-up"></i>
                    }
                    @case ('points_low') {
                      <i class="fa-solid fa-arrow-down"></i>
                    }
                    @case ('combined') {
                      <i class="fa-solid fa-calculator"></i>
                    }
                  }
                </div>
                <span class="score-type-label">{{ option.labelKey | translate }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="row g-4 spacing-15">
        <div class="col-12">
          <label class="form-label">{{ 'scoring.penaltyType' | translate }} *</label>
          <div class="penalty-type-options">
            @for (option of penaltyTypeOptions; track option.value) {
              <div
                class="penalty-type-card"
                [class.selected]="form.get('penalty_type')?.value === option.value"
                (click)="form.get('penalty_type')?.setValue(option.value)"
              >
                <div class="penalty-type-icon">
                  @if (option.value === 'time') {
                    <i class="fa-solid fa-clock"></i>
                  } @else {
                    <i class="fa-solid fa-hashtag"></i>
                  }
                </div>
                <span class="penalty-type-label">{{ option.labelKey | translate }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      @if (isCombinedScoring) {
        <div class="row g-4 spacing-15">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'scoring.timeWeight' | translate"
              [type]="'number'"
              [value]="form.get('time_weight')?.value"
              (valueChange)="form.get('time_weight')?.setValue($event)"
              [floating]="true"
            ></app-input-component>
          </div>
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'scoring.pointsWeight' | translate"
              [type]="'number'"
              [value]="form.get('points_weight')?.value"
              (valueChange)="form.get('points_weight')?.setValue($event)"
              [floating]="true"
            ></app-input-component>
          </div>
        </div>
      }

      <div class="row g-4 spacing-15">
        <div class="col-lg-6 col-12">
          <app-input-component
            [label]="'scoring.decimalPlaces' | translate"
            [type]="'number'"
            [value]="form.get('decimal_places')?.value"
            (valueChange)="form.get('decimal_places')?.setValue($event)"
            [floating]="true"
          ></app-input-component>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="form.invalid || saving || loading"
      (click)="save()"
    >
      @if (saving) {
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
      }
      {{ 'common.save' | translate }}
    </button>
  </div>
</form>
